import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';

function VehicleDetailsCard({
    rodac,
    typeCoverage,
    typeEngine,
    typeRegimeState,
    typeRegimeOptions,
    stateAmple,
    setClass,
    cleanErrors,
    updateRodac,
    onTypeEngineChange,
    onTypeRegimeChange,
    onStatePlateChange,
}) {
    return (
        <section className='FormCard'>
            <div className='SectionHeader'>
                <div>
                    <h2>Detalles del vehículo</h2>
                </div>
            </div>

            <div className='CardGrid'>
                <div className='Field'>
                    <label className='FieldLabel'>Condición</label>
                    <Dropdown
                        value={rodac.car_status_select}
                        options={rodac.car_statuses}
                        optionLabel="status"
                        name="car_status_select"
                        placeholder="Condición"
                        className="Dropdown"
                        onChange={event => {
                            updateRodac({
                                car_status_id: event.target.value.id === '' ? null : event.target.value.id,
                                car_status_select: event.value,
                                model_id: null,
                                model_select: null,
                                models: [],
                                brand: null,
                                brand_select: null,
                                brands: [],
                                type: null,
                                type_select: null,
                                types: [],
                                description_id: null,
                                description_select: null,
                                descriptions: [],
                                amount: null,
                            });
                        }}
                    />
                </div>

                <div className='Field'>
                    <label className='FieldLabel'>Tipo</label>
                    <Dropdown
                        value={rodac.car_type_select}
                        name="car_type_select"
                        options={rodac.car_types}
                        optionLabel="type"
                        placeholder="Tipo"
                        className={setClass('car_type_select') ? 'DropdownError' : 'Dropdown'}
                        onChange={event => {
                            cleanErrors('car_type_select');
                            updateRodac({
                                car_type_id: event.target.value.id === '' ? null : event.target.value.id,
                                car_type_select: event.value,
                                // Los años (models) no dependen del tipo, se mantienen
                                // pero se resetea la selección para forzar re-elegir
                                model_id: null,
                                model_select: null,
                                brand: null,
                                brand_select: null,
                                brands: [],
                                type: null,
                                type_select: null,
                                types: [],
                                description_id: null,
                                description_select: null,
                                descriptions: [],
                                amount: null,
                            });
                        }}
                    />
                </div>

                <div className='Field'>
                    <label className='FieldLabel'>Año</label>
                    <Dropdown
                        value={rodac.model_select}
                        options={rodac.models.filter(item => item.id !== 0)}
                        optionLabel="model"
                        placeholder="Año"
                        name="model_select"
                        filter
                        className={setClass('model_year') ? 'DropdownError custom-dropdown' : 'Dropdown custom-dropdown'}
                        onChange={event => {
                            cleanErrors('model_year');
                            updateRodac({
                                model_id: event.target.value.id === '' ? null : event.target.value.id,
                                model_select: event.value,
                                brand: null,
                                brand_select: null,
                                brands: [],
                                type: null,
                                type_select: null,
                                types: [],
                                description_id: null,
                                description_select: null,
                                descriptions: [],
                                amount: null,
                            });
                        }}
                    />
                </div>

                <div className='Field'>
                    <label className='FieldLabel'>Marca</label>
                    <Dropdown
                        value={rodac.brand_select}
                        options={rodac.brands}
                        optionLabel="brand"
                        placeholder="Marca"
                        name="brand_select"
                        filter
                        className={setClass('brand') ? 'DropdownError' : 'Dropdown'}
                        onChange={event => {
                            cleanErrors('brand');
                            updateRodac({
                                brand: event.target.value.brand === '' ? null : event.target.value.brand,
                                brand_select: event.value,
                                type: null,
                                type_select: null,
                                types: [],
                                description_id: null,
                                description_select: null,
                                descriptions: [],
                                amount: null,
                            });
                        }}
                    />
                </div>

                <div className='Field'>
                    <label className='FieldLabel'>Modelo</label>
                    <Dropdown
                        value={rodac.type_select}
                        options={rodac.types}
                        optionLabel="type"
                        placeholder="Modelo"
                        name="type_select"
                        filter
                        className={setClass('model_name') ? 'DropdownError' : 'Dropdown'}
                        onChange={event => {
                            cleanErrors('model_name');
                            updateRodac({
                                type: event.target.value.type === '' ? null : event.target.value.type,
                                type_select: event.value,
                                description_id: null,
                                description_select: null,
                                descriptions: [],
                                amount: null,
                            });
                        }}
                    />
                </div>

                <div className='Field'>
                    <label className='FieldLabel'>Versión</label>
                    <Dropdown
                        value={rodac.description_select}
                        options={rodac.descriptions}
                        optionLabel="description"
                        placeholder="Versión"
                        name="description_select"
                        filter
                        className={setClass('model_version') ? 'DropdownError' : 'Dropdown'}
                        onChange={event => {
                            cleanErrors('model_version');
                            updateRodac({
                                description_id: event.target.value.id === '' ? null : event.target.value.id,
                                description_select: event.value,
                            });
                        }}
                    />
                </div>

                <div className='Field'>
                    <label className='FieldLabel'>Precio del vehículo</label>
                    <InputText
                        keyfilter="money"
                        value={rodac.amount ?? ''}
                        className={setClass('amount') ? 'TextInputError' : 'TextInput'}
                        placeholder='Precio c/IVA'
                        name="amount"
                        onChange={event => {
                            cleanErrors('amount');
                            const val = event.target.value === '' ? null : parseFloat(event.target.value.replace(/,/g, ''));
                            updateRodac({ amount: isNaN(val) ? null : val });
                        }}
                    />
                </div>

                <div className='Field'>
                    <label className='FieldLabel'>Accesorios</label>
                    <InputText
                        keyfilter="money"
                        value={rodac.accesorios ?? ''}
                        className='TextInput'
                        placeholder='Accesorios c/IVA (opcional)'
                        name="accesorios"
                        onChange={event => {
                            const val = event.target.value === '' ? null : parseFloat(event.target.value.replace(/,/g, ''));
                            updateRodac({ accesorios: isNaN(val) ? null : val }, false);
                        }}
                    />
                </div>

                <div className='Field'>
                    <label className='FieldLabel'>Motor</label>
                    <Dropdown
                        value={typeEngine.typeEngineName}
                        options={[
                            { id: 1, type_engine: 'Gasolina/Diesel' },
                            { id: 2, type_engine: 'Híbrido/Eléctrico' }
                        ]}
                        optionLabel="type_engine"
                        placeholder="Tipo de Motor"
                        name="type_engine_select"
                        className={setClass('type_engine') ? 'DropdownError' : 'Dropdown'}
                        onChange={onTypeEngineChange}
                    />
                </div>

                {typeCoverage.typeCoverageName?.id === 2 && (
                    <div className='Field'>
                        <label className='FieldLabel'>Régimen</label>
                        <Dropdown
                            value={typeRegimeState.typeRegimeName}
                            options={typeRegimeOptions?.map(item => ({ id: item.id, name: item.name }))}
                            optionLabel="name"
                            placeholder="Régimen"
                            name="type_regime_select"
                            filter
                            className={setClass('typeRegime') ? 'DropdownError' : 'Dropdown'}
                            onChange={onTypeRegimeChange}
                        />
                    </div>
                )}

                <div className='Field FieldWide'>
                    <label className='FieldLabel'>Estado de placa</label>
                    <Dropdown
                        value={rodac.estado_placa}
                        options={stateAmple}
                        placeholder="Estado de la placa"
                        optionLabel="state"
                        name="estado_placa_select"
                        filter
                        className={setClass('estado_placa') ? 'DropdownError' : 'Dropdown'}
                        onChange={event => onStatePlateChange(event.target.value === '' ? null : event.target.value)}
                    />
                </div>
            </div>
        </section>
    );
}

export { VehicleDetailsCard };
